import BaseEntity from "../BaseEntity";
import Guid from "../Guid";
import SeedOrderClassGrade from "./SeedOrderClassGrade";

export default class SeedOrderClass extends BaseEntity {
  SeedOrderId = Guid.Empty;
  SeedOrderClassGrades: SeedOrderClassGrade[] = [];
}
